<style scoped lang="scss">
</style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/config/operationLog/page" getKey="rows"
			:columns="columns" @expandChange="expandChange">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('yonghuzhanghao')">
						<el-input v-model="yt.conditions.username"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yonghumingcheng')">
						<el-input v-model="yt.conditions.nickname"></el-input>
					</el-form-item>
					<el-form-item :label="$t('caozuomiaoshu')">
						<el-input v-model="yt.conditions.description"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhongduanIP')">
						<el-input v-model="yt.conditions.clientIp"></el-input>
					</el-form-item>
					<el-form-item :label="$t('caozuoshijian')">
						<yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime"
							:end.sync="yt.conditions.endTime">
						</yi_time_input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain>
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<template #caozuomiaoshu="scope">
				{{$t(scope.row.i18nKey)}}
			</template>
		</yi_curd_table>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'admin_system_user_log_list',

		data() {
			return {
				list: [],
				columns: [{
						label: 'caozuoshijian',
						prop: 'createTime',
						type: 'time',
						width: 230,
					},
					{
						label: 'yonghuzhanghao',
						prop: 'username',
					},
					{
						label: 'yonghumingcheng',
						prop: 'nickname'
					},
					{
						label: 'zhongduanIP',
						prop: 'clientIp',
					},
					{
						label: 'caozuomiaoshu',
						type: 'slot',
					},
				],
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.get(1);
				this.getList()
			}, 300)

		},
		methods: {
			// 获取列表数据
			async getList() {
				let response = await this.http.get('/web/config/dictItem/page', {
					params:{
						pageNum: 1,
						pageSize: 1000
					}
					
				})
				console.log("list", response.data.rows)
				this.list = response.data.rows
			},
			// 重置
			clear() {
				this.yt.conditions = {
					pageNum: 1,
					pageSize: 1000
				}
				this.get(1)
			},

			expandChange(a, b) {
				console.log(a, b)
			},

			//重构这个函数，正常返回请求参数，不通过就返回false
			beforeGet(params) {
				if (!params.platform) {
					this.utils.errorMessage(this.$t("Please choose a platform"))
					return false
				}

				return params
			},

			beforeReq(params, url) {
				//是否外链这个是隐藏的，所以我们默认设置为false
				if (url == "/web/system/auth/menu/create" || url == "/web/system/auth/menu/update") {
					params.frame = false
				}
				return params
			},
		},
	};
</script>
